<div class="row p-3">
    <div class="col-12">
        <h4>Edit {{position}} position notes</h4>
    </div>
    <div class="col-12 text-center">
        <textarea mdbInput class="form-control pd-options-notes" rows="2" placeholder="Optional" [(ngModel)]="notes"></textarea>
    </div>
    <div class="col-12 text-center mt-2">
        <button class="btn btn-rounded btn-primary w-100" type="button" (click)="close(notes)">
            Save
        </button>
    </div>
</div>